import { createAsyncThunk } from '@reduxjs/toolkit';

import { REDUCER_ENUMS } from '../../../enums/applicationEnums';
import { handleError } from '../../../utility/helpers';

export const storeAdminUsersFiltersData = createAsyncThunk(
    REDUCER_ENUMS.ADMIN_USERS_FILTERS,
    async (filtersObject: any, { rejectWithValue }) => {
        try {
            return filtersObject;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    },
);

export const storeAdminTiersFiltersData = createAsyncThunk(
    REDUCER_ENUMS.ADMIN_TIERS_FILTERS,
    async (filtersObject: any, { rejectWithValue }) => {
        try {
            return filtersObject;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    },
);

export const storeCandidatesSelectionFilters = createAsyncThunk(
    'employer-candidates-filters',
    async (filtersObject: any, { rejectWithValue }) => {
        try {
            return filtersObject;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    },
);

export const storeSavedJobsFilters = createAsyncThunk(
    'saved-jobs-filters',
    async (filtersObject: any, { rejectWithValue }) => {
        try {
            return filtersObject;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    },
);

export const clearFiltersState = createAsyncThunk(
    REDUCER_ENUMS.CLEAR_FILTERS,
    async () => {
        return null;
    }
);
